/**
 * Pushy Menu - Simple slide-out navigation
 */
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    const body = document.body;
    const pushy = document.querySelector('.pushy');
    const menuBtn = document.querySelector('.menu-btn');
    const siteOverlay = document.querySelector('.site-overlay');
    const pushySubmenus = document.querySelectorAll('.pushy-submenu');

    if (!pushy || !menuBtn) return;

    const isRight = pushy.classList.contains('pushy-right');
    const openClass = isRight ? 'pushy-open-right' : 'pushy-open-left';

    // Toggle menu on button click
    menuBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      toggleMenu();
    });

    // Close menu when clicking overlay
    if (siteOverlay) {
      siteOverlay.addEventListener('click', function() {
        closeMenu();
      });
    }

    // Close menu on escape key
    document.addEventListener('keyup', function(e) {
      if (e.key === 'Escape') {
        closeMenu();
      }
    });

    // Handle submenu toggles
    pushySubmenus.forEach(function(submenu) {
      const btn = submenu.querySelector('.pushy-btn');
      if (btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          submenu.classList.toggle('pushy-submenu-open');
        });
      }
    });

    function toggleMenu() {
      if (body.classList.contains(openClass)) {
        closeMenu();
      } else {
        openMenu();
      }
    }

    function openMenu() {
      body.classList.add(openClass);
      menuBtn.classList.add('active');
    }

    function closeMenu() {
      body.classList.remove('pushy-open-left', 'pushy-open-right');
      menuBtn.classList.remove('active');
    }

    // Expose close function globally (used by cart drawer)
    window.closePushyMenu = closeMenu;
  });
})();
